module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"shipping_zone_options":"Shipping zone options at checkout are","turn_on_local_order":"Turn on local order settings for this form"},"id":{"shipping_zone_options":"Zona pengiriman di checkout:","turn_on_local_order":"Aktifkan pengaturan pesanan lokal untuk form ini"}}')
  delete Component.options._Ctor
}
